/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import EffectSplatter from "../../../assets/images/effect-splatter.png";
import BJB from "../../../assets/images/sponsor/bjb.png";
import LogoPemkot from "../../../assets/images/sponsor/logo_pemkot_surabaya.png";
import Kompas from "../../../assets/images/sponsor/kompas.png";
import LogoLeMineral from "../../../assets/images/sponsor/leminerale.png"
import LogoIsoplus from "../../../assets/images/sponsor/isoplus.png"
import LogoHydroCoco from "../../../assets/images/sponsor/hydrococo.png"
import LogoGenerali from "../../../assets/images/sponsor/Generali Logo B Stripes Red (1).png"
import LogoMyPertamina from "../../../assets/images/sponsor/mypertamina.png"
import LogoEJSport from "../../../assets/images/sponsor/ejsport.png"
import LogoZinc from "../../../assets/images/sponsor/logo-zinc.jpg"
import LogoAzzura from "../../../assets/images/sponsor/azzura.jpeg"
import LogoCiptadenFresh from "../../../assets/images/sponsor/logo-ciptadent-fresh.png"
import LogoPosh from "../../../assets/images/sponsor/posh.png"
import LogoFitbar from "../../../assets/images/sponsor/fitbar.png"
import LogoPilkitaHerbal from "../../../assets/images/sponsor/logo-pilkita-herbal.png"
import LogoAntangin from "../../../assets/images/sponsor/logo-antangin.png"
import LogoCardea from "../../../assets/images/sponsor/logo-cardea.jpg"
import LogoHotelSantika from "../../../assets/images/sponsor/logo-hotel-santika.png"
import LogoShokz from "../../../assets/images/sponsor/shokz.png"
import LogoGarmin from "../../../assets/images/sponsor/garmin.png"
import LogoOliveMilk from "../../../assets/images/sponsor/logo-olive-milk.png"
import LogoTribun from "../../../assets/images/sponsor/logo-tribun-network.png"
import LogoRadioM from "../../../assets/images/sponsor/logo-radio-98.png"
import LogoCeritaPelari from "../../../assets/images/sponsor/logo-cerita-pelari.png"
import LogoKalenderLari from "../../../assets/images/sponsor/logo-kalender-lari.png"
import LogoAsics from "../../../assets/images/sponsor/logo-asics.png"
import LogoRhea from "../../../assets/images/sponsor/logo-rhea.png"
import LogoByd from "../../../assets/images/sponsor/logo-byd.png"
import LogoZoll from "../../../assets/images/sponsor/zoll.png"
import LogoMayapada from "../../../assets/images/sponsor/logo-rs-mayapada.png"
import LogoTehPucuk from "../../../assets/images/sponsor/logo-teh-pucuk.png"

export default function Sponsor() {
    return (
        <div className="bg-white font-roboto overflow-hidden">
            <div className="relative container w-full mx-auto py-24 overflow-hidden">
                <img
                    src={EffectSplatter}
                    alt="Decorative splatter effect"
                    className="absolute top-64 md:top-48 object-contain z-1 opacity-50 pointer-events-none select-none"
                />
                <div className="relative z-10 grid grid-cols-3 uppercase gap-2 md:gap-10 py-10">
                    <div className="flex flex-col justify-start items-center">
                        <h2 className="text-base lg:text-xl leading-none md:text-xs md:text-sm text-black">Powered By</h2>
                        <a href="https://www.bankbjb.co.id/" target="_blank" rel="noreferrer">
                            <img src={BJB} alt="logo-bjb" className="w-24 md:w-64 h-auto pt-4" />
                        </a>
                    </div>
                    <div className="flex flex-col justify-start items-center">
                        <h2 className="text-base lg:text-xl leading-none md:text-xs md:text-sm text-black">Managed By</h2>
                        <a href="https://www.kompas.id/" target="_blank" rel="noreferrer">
                            <img src={Kompas} alt="logo-kompas" className="w-28 md:w-64 h-auto md:-mt-4" />
                        </a>
                    </div>
                    <div className="flex flex-col justify-start items-center">
                        <h2 className="text-base lg:text-xl leading-none md:text-xs md:text-sm text-black">Government Partner By</h2>
                        <div className="flex h-full items-center justify-center">
                            <a href="https://www.surabaya.go.id/" target="_blank" rel="noreferrer">
                                <img src={LogoPemkot} alt="logo-pemkot-surabaya" className="w-auto h-24 md:h-36 -mt-2" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto py-0 grid grid-cols-1">
                    <div className="grid md:grid-cols-4 uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">Official Mineral Water</h2>
                            <a href="https://www.leminerale.com/" target="_blank" rel="noreferrer">
                                <img src={LogoLeMineral} alt="logo-lemineral" className="w-44 xl:w-56 flex justify-center" />
                            </a>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">Official Isotonic</h2>
                            <a href="https://wingscorp.com/brand-detail/isoplus/" target="_blank" rel="noreferrer">
                                <img src={LogoIsoplus} alt="logo-isoplus" className="w-48 xl:w-56 flex justify-center" />
                            </a>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">Official Healthy Drink</h2>
                            <a href="https://hydrococo.com/" target="_blank" rel="noreferrer">
                                <img src={LogoHydroCoco} alt="logo-hydro-coco" className="w-36 xl:w-48 md:pt-6 flex justify-center" />
                            </a>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">Official Insurance</h2>
                            <a href="https://www.generali.co.id/" target="_blank" rel="noreferrer">
                                <img src={LogoGenerali} alt="logo-generali" className="w-48 xl:w-56 md:pt-20 flex justify-center" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto pt-20 grid grid-cols-1">
                    <div className="grid md:grid-cols-3 uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-start items-center col-span-3">
                            <h2 className="text-base lg:text-xl font-normal">Co Sponsor</h2>
                            <div className="grid grid-cols-2 md:grid-cols-8 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.pertamina.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoMyPertamina} alt="logo-my-pertamina" className="w-32 md:w-28 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://asics.co.id" target="_blank" rel="noreferrer">
                                        <img src={LogoAsics} alt="logo-asics" className="w-24 md:w-24 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://ejsportofficial.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoEJSport} alt="logo-ej-sport" className="w-24 md:w-20 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.zinc.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoZinc} alt="logo-zinc" className="w-24 md:w-16 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://azzuracosmetics.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoAzzura} alt="logo-azzura" className="w-32 md:w-28 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://ciptadent.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoCiptadenFresh} alt="logo-ciptadent-fresh" className="w-32 md:w-24 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.poshindonesia.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoPosh} alt="logo-posh" className="w-32 md:w-24 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://kalbenutritionals.com/id/produk-kami/fitbar" target="_blank" rel="noreferrer">
                                        <img src={LogoFitbar} alt="logo-fitbar" className="w-32 md:w-24 object-contain" />
                                    </a>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-12 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.deltomed.id/our-brands/pilkita-1" target="_blank" rel="noreferrer">
                                        <img src={LogoPilkitaHerbal} alt="logo-pilkita-herbal" className="w-28 md:w-32 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.deltomed.id/our-brands/antangin" target="_blank" rel="noreferrer">
                                        <img src={LogoAntangin} alt="logo-antangin" className="w-32 md:w-36 object-contain" />

                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.mysantika.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoHotelSantika} alt="logo-hotel-santika" className="w-32 md:w-40 object-contain" />

                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://cardea.asia/" target="_blank" rel="noreferrer">
                                        <img src={LogoCardea} alt="logo-cardea" className="w-32 md:w-36 object-contain" />

                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://rhea.co.id" target="_blank" rel="noreferrer">
                                        <img src={LogoRhea} alt="logo-rhea" className="w-32 md:w-36 object-contain" />

                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.byd.com/id" target="_blank" rel="noreferrer">
                                        <img src={LogoByd} alt="logo-byd" className="w-32 md:w-36 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://asia.shokz.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoShokz} alt="logo-shokz" className="w-32 md:w-36 object-contain" />

                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.garmin.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoGarmin} alt="logo-garmin" className="w-32 md:w-36 object-contain" />

                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://entrasol.com" target="_blank" rel="noreferrer">
                                        <img src={LogoOliveMilk} alt="logo-olive-milk" className="w-20 md:w-24 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.zoll.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoZoll} alt="logo-zoll" className="w-20 md:w-24 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://mayapadahospital.com/hospital/mayapada-hospital-surabaya" target="_blank" rel="noreferrer">
                                        <img src={LogoMayapada} alt="logo-rs-mayapada" className="w-20 md:w-28 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://instagram.com/pucukharumid" target="_blank" rel="noreferrer">
                                        <img src={LogoTehPucuk} alt="logo-olive-milk" className="w-20 md:w-20 object-contain" />
                                    </a>
                                </div>
                            </div>
                            {/* <div className="grid grid-cols-2 md:grid-cols-5 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoEcohome} alt="logo-pace-and-place" className="w-32 md:w-36 object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoShokz} alt="logo-pace-and-place" className="w-32 md:w-36 object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoSh} alt="logo-pace-and-place" className="w-32 md:w-36 object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoNomadGrounds} alt="logo-pace-and-place" className="w-32 md:w-36 object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoGoldenTulip} alt="logo-pace-and-place" className="w-32 md:w-36 object-contain" />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto py-20 grid grid-cols-1">
                    <div className="grid md:grid-cols-3 uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-start items-center col-span-3">
                            <h2 className="text-base lg:text-xl font-normal">Media Partner</h2>
                            <div className="grid grid-cols-2 md:grid-cols-4 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.tribunnews.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoTribun} alt="logo-tribun-network" className="w-32 md:w-40 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.instagram.com/mradiosby/#" target="_blank" rel="noreferrer">
                                        <img src={LogoRadioM} alt="logo-radio-m" className="w-24 md:w-36 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.instagram.com/ceritapelari/" target="_blank" rel="noreferrer">
                                        <img src={LogoCeritaPelari} alt="logo-cerita-pelari" className="w-24 md:w-40 object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.instagram.com/kalenderlari/" target="_blank" rel="noreferrer">
                                        <img src={LogoKalenderLari} alt="logo-kalender-lari" className="w-32 md:w-40 object-contain" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
